var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(user){return _c('div',{key:user.guid,staticClass:"mb-2"},[_c('div',{staticClass:"body",class:{
      'pl-2': _vm.withPadLeft
    }},[(_vm.enableDelete)?_c('v-icon',{staticClass:"red--text pointer",attrs:{"small":""},on:{"click":function($event){return _vm.removeSelectedUser(user)}}},[_vm._v("mdi-close")]):_vm._e(),_c('span',[_vm._v(_vm._s(user.name)+" "+_vm._s(user.surname))])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }